<template>
  <div @scroll="handleScroll" class="main-content">
    <!-- Page Header Start -->
    <PageHeader
      :pageHeaderBackgroundImageSrc="item?.mainImage"
      :hasOverlay="true"
      :headerBackgroundOpacity="0.7"
    >
      <PageHeaderTitleContent>
        <TitleTextContent
          :titleText="item?.title"
        />
        <router-link 
          v-if="blogPage"
          :to="{ 
            name: isRecentBlogs === 'true' ? 'blog' : 'blogArchives', 
            query: { 
              blogPage: blogPage, 
              query: query,
            } 
          }"
        >
          <v-btn
            rounded
            large
            dark
            :color="'#424EC4'"
          >
            {{ isRecentBlogs === 'true' ? "Read All Recent Blogs" : "Read All Archive Blogs" }}
          </v-btn>
        </router-link>
        <router-link 
          v-else
          :to="{
            name: 'cybercorner',
          }"
        >
          <v-btn
            rounded
            large
            dark
            :color="'#424EC4'"
          >
            Back to Cyber Corner
          </v-btn>
        </router-link>
      </PageHeaderTitleContent>
    </PageHeader>
    <!-- Page Header End -->

    <!-- Login Modal -->
    <b-modal size="lg" ref="my-like-modal" hide-footer centered title="Want to Like this post?">
      <p class="my-1">
        Please
        <router-link :to="{
        name: 'login', query: { redirect: this.$route.path, queryString: this.queryString, queryValue: this.queryValue }
      }">
          <a>LOGIN</a>
        </router-link>
        or
        <router-link :to="{ name: 'signup' }">
          <a>SIGN UP</a>
        </router-link>
        to like content.
      </p>
    </b-modal>
    <!-- End Login Modal -->

    <!-- Login Modal -->
    <b-modal size="lg" ref="my-modal" hide-footer centered title="Want to bookmark this for later?">
      <p class="my-4">
        Please
        <router-link :to="{
        name: 'login', query: { redirect: this.$route.path, queryString: this.queryString, queryValue: this.queryValue  }
      }">
          <a>LOGIN</a>
        </router-link>
        or
        <router-link :to="{ name: 'signup' }">
          <a>SIGN UP</a>
        </router-link>
        to bookmark content.
      </p>
    </b-modal>
    <!-- End Login Modal -->

    <!-- Start Top Social Media -->
    <SocialMediaWidgets
      :title="title"
      :description="description"
      :type="'blogs-top'"
      :isSocialMediaSiblingsVisible="true"
    >
      <div class="col-6 col-lg-3 col-xl-3 p-0">
        <p class="post-snippet text-start">{{ item?.author }}</p>
      </div>
      <div class="col-6 col-lg-3 col-xl-3 p-0">
        <p class="post-snippet text-right text-lg-left text-xl-left">{{ getFormattedDate(item?.date) }}</p>
      </div>
      <div class="col-6 col-lg-3 col-xl-3 p-0 mt-2 mt-lg-0 mt-xl-0">
        <p class="post-snippet text-start text-lg-left text-xl-left">Cyber Security</p>
      </div>
    </SocialMediaWidgets>
    <!-- End Top Social Media -->

    <!-- Blog Details Start -->
    <section class="section-content">
      <div class="container my-3 px-3 px-lg-0 px-xl-0">
        <span v-html="item?.article">
        </span>
      </div>
    </section>
    <!-- Blog Details End -->

    <!-- Start Bottom Social Media -->
    <SocialMediaWidgets
      :title="title"
      :description="description"
      :type="'blogs-bottom'"
      :isSocialMediaSiblingsVisible="true"
      :hasBottomMargin="true"
      :socialShareColumnClass="'col-12'"
      :socialShareFlexJustifyClass="socialMediaFlexJustify"
    >
      <div class="col-12 col-lg-9 col-xl-9 p-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start">
        <div :style="{ 'width': bottomRowLikesBookmarksWidth }" class="d-flex flex-row justify-content-between">
          <div class="mr-4" v-on:click="initiateLike()">
            <FlatIconButton label="Like" icon="mdi mdi-thumb-up-outline" v-if="this.liked === false" />
            <FlatIconButton label="Liked" icon="mdi mdi-thumb-up" v-if="this.liked === true" />
          </div>
          <p class="social-button-area-left-text">
            <span class="mr-4">{{ likeText }}</span>
            <!-- <span class="mr-4">|</span>
            <span>0 Shares</span> -->
          </p>
          <div class="pl-1 bookmark-page" v-if="!isPageBookmarked" v-on:click="onBookmarkPage">
            <div id="tooltip-bookmark">
              <font-awesome-icon :icon="['far', 'bookmark']"/>
              Bookmark
            </div>
            <b-tooltip variant="primary" target="tooltip-bookmark">Click to bookmark page</b-tooltip>
          </div>
          <!-- Page Already Bookmarked -->
          <div class="pl-1 bookmark-page" v-else v-on:click="onBookmarkPage">
            <font-awesome-icon id="tooltip-bookmark" :icon="['fas', 'bookmark']"/>
            Bookmarked
            <b-tooltip variant="success" target="tooltip-bookmark">Bookmarked!</b-tooltip>
          </div>
        </div>
      </div>
    </SocialMediaWidgets>
    <!-- End Bottom Social Media -->

    <!-- Start Read Previous and Next Article -->
    <section class="section-content">
      <div class="container mb-5 my-3 px-3 px-lg-0 px-lg-0 px-xl-0">
        <div class="row m-0">
          <div 
            class="col-12 col-lg-6 col-xl-6 p-0 mb-lg-0 mb-xl-0 d-flex flex-row justify-content-center justify-content-lg-start justify-content-xl-start"
            :class="previousButtonMarginBottomClass"
          >
            <v-btn
              v-if="previousBlogId" 
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="() => goToPreviousOrNextBlogItem(previousBlogId, '#/blogdetail')"
            >
              Read Previous
            </v-btn>
          </div>

          <div 
            class="col-12 col-lg-6 col-xl-6 p-0 mt-lg-0 mt-xl-0 d-flex flex-row justify-content-center justify-content-lg-end justify-content-xl-end"
            :class="nextButtonMarginTopClass"
          >
            <v-btn
              v-if="nextBlogId" 
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="() => goToPreviousOrNextBlogItem(nextBlogId, '#/blogdetail')"
            >
              Read Next
            </v-btn>
          </div>
        </div>
      </div>
    </section>
    <!-- End Read Previous and Next Article -->

    <!-- Start the comments entry section -->
    <!--section  class="section-content">
      <div class="container create-comment-area my-3 px-3 px-lg-0 px-lg-0 px-xl-0">
        <LoadingSpinner label="Now creating comment" v-if="createCommentLoading" />
        <div v-else class="row m-0 mb-5">
          <div class="col-12 p-0 d-flex flex-column">
            <span class="comments">COMMENTS</span>
            <h3>Join the Conversation</h3>
            <p class="paragraph-text" :class="paragraphTextClass">Email address will not be displayed. All fields mandatory.</p>
          </div>

          <div class="col-12 p-0 comment-area">
            <textarea 
              class="form-control text-area-stripped" 
              id="commentsField"
              @focus="() => { commentBodyError = false }" 
              v-model="commentBody" 
              :rows="textAreaRows"
            >
            </textarea>
            <div class="emoticon-area">
              <emoji-picker @emoji="insert" :search="search">
                <div slot="emoji-invoker" slot-scope="{ events: { click: clickEvent } }"
                  @click.stop="clickEvent">
                  <button type="button"><i class="mdi mdi-emoticon"></i></button>
                </div>
                <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
                  <div>
                    <div>
                      <input type="text" v-model="search">
                    </div>
                    <div>
                      <div v-for="(emojiGroup, category) in emojis" :key="category">
                        <h5>{{ category }}</h5>
                        <div>
                          <span v-for="(emoji, emojiName) in emojiGroup" :key="emojiName"
                            @click="insert(emoji)" :title="emojiName">{{ emoji }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </emoji-picker>
            </div>
            <h5 v-if="commentBodyError" class="form-error">Please enter comment !</h5>
          </div>

          <div v-if="!isLoggedIn" class="col-12 col-md-6 col-lg-6 col-xl-6 pl-0 pt-4 pb-4 pr-2">
            <label for="nameField" class="form-label input-text-label">Name</label>
            <input 
              type="text" 
              class="form-control input-text" 
              id="nameField" 
              @focus="() => { commentNameError = false }"
              v-model="commentName" 
              placeholder="Enter name"
            >
            <h5 v-if="commentNameError" class="form-error">Please enter name !</h5>
          </div>

          <div v-if="!isLoggedIn" class="col-12 col-md-6 col-lg-6 col-xl-6 pr-0 pt-4 pb-4 pl-0 pl-lg-2 pl-xl-2">
            <label for="emailField" class="form-label input-text-label">Email address </label>
            <input 
              type="email" 
              class="form-control input-text" 
              id="emailField"
              @focus="() => { commentEmailError = false }" 
              v-model="commentEmail" 
              placeholder="Enter email"
            >
            <h5 v-if="commentEmailError" class="form-error">Please enter valid email !</h5>
          </div>

          <div class="col-12 p-0 mt-4 d-flex justify-content-center justify-content-lg-start justify-content-xl-start">
            <div v-if="commentSubmitted" class="alert alert-success" role="alert">
              <i class="mdi mdi-checkbox-marked-circle"></i> 
              <span>Your comment has been submitted. The comment will only be visible after moderation and approval from Project Spectrum.</span>
            </div>
            <v-btn
              v-else
              rounded
              large
              dark
              :color="'#424EC4'"
              width="240"
              @click="createComment"
            >
              Submit Comment
            </v-btn>
          </div>

          <div class="col-12 p-0 mt-4 view-comments-area">
            <LoadingSpinner label="Now getting latest comments" v-if="commentsLoading" />
            <div v-else-if="comments.length > 0" class="comments-container">
              <CommentBadge 
                v-for="comment in comments" 
                :key="comment.id" 
                :name="comment.commentName"
                :body="comment.commentBody" 
                :date="comment.commentDate" 
              />
            </div>
            <div v-else class="empty-comments-message">
              There are no comments available for this cyber blog article
            </div>
          </div>
        </div>
      </div>
    </section-->
    <!-- End the comments entry section -->

    <!-- Blog Details Section End-->
  </div>
</template>
<script>
import { BFormInput } from 'bootstrap-vue';
import axios from 'axios';
import moment from 'moment';
import { isLoggedIn, handleApiError } from '../utils/authentication';
import CommentBadge from './library/badges/comment-badge.vue';
import FlatIconButton from './library/buttons/flat-icon-button';
import SolidTextButton from './library/buttons/solid-text-button.vue';
import LoadingSpinner from './library/widgets/loading-spinner.vue';
import EmojiPicker from 'vue-emoji-picker'
import PageHeader from "./library/widgets/page-header.vue";
import PageHeaderTitleContent from "./library/widgets/page-header-title-content.vue";
import TitleTextContent from './library/widgets/title-text-content.vue';
import SocialMediaWidgets from './library/widgets/social-media-widgets.vue';
import { EventBus } from '../utils/eventBus';
export default {
  name: 'blogdetail',
  components: {
    BFormInput,
    CommentBadge,
    FlatIconButton,
    SolidTextButton,
    LoadingSpinner,
    EmojiPicker,
    PageHeader,
    PageHeaderTitleContent,
    TitleTextContent,
    SocialMediaWidgets,
  },
  props: {
    id: String,
    blogPage: String,
    query: String,
    isRecentBlogs: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      item: {},
      comments: [],
      commentsLoading: false,
      commentBody: "",
      search: '',
      commentName: "",
      commentEmail: "",
      commentBodyError: false,
      commentNameError: false,
      commentEmailError: false,
      createCommentLoading: false,
      commentSubmitted: false,
      liked: false,
      likeId: null,
      numOfLikes: 0,
      titleVisible: true,
      isPageBookmarked: false,
      isPageBookmarkedId: null,
      queryValue: this.id, 
      queryString: "id",
      previousBlogId: null,
      nextBlogId: null,
    };
  },
  async created() {

    if (this.id) {
      await this.getResource(this.id);
      this.loadLike(this.id);
      this.loadLikeNum(this.id);
      if (isLoggedIn()) {
        this.checkIfBookmarked()
      }
      await this.getComments()
    } else {
      this.$router.push({ path: 'blog' });
    }

    window.addEventListener('scroll', this.handleScroll);

  },
  unmounted () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted() {
    this.init();
  },
  computed: {
    likeText() {
      return `${this.numOfLikes} ${this.numOfLikes === 1 ? 'Like' : 'Likes'}`;
    },
    isLoggedIn() {
      return isLoggedIn();
    },
    title() {
      return this.item?.title || 'Title';
    },
    description() {
      return this.item?.headLine || 'HeadLine';
    },
    url() {
      return window.location.hash || 'URL';
    },
    isMobile() {
      return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm);
    },
    socialMediaFlexJustify() {
      return this.isMobile || this.$vuetify.breakpoint.md ? 'justify-content-center' : 'justify-content-end';
    },
    bottomRowLikesBookmarksWidth() {
      return this.isMobile || this.$vuetify.breakpoint.md ? '90%' : '30%';
    },
    previousButtonMarginBottomClass() {
      return this.isMobile && this.previousBlogId && this.nextBlogId ? 'mb-3' : 'mb-0';
    },
    nextButtonMarginTopClass() {
      return this.isMobile && this.nextBlogId && this.previousBlogId ? 'mt-3' : 'mt-0';
    },
    paragraphTextClass() {
      return this.isMobile ? 'paragraph-text-xs-sm' : 'paragraph-text-md-lg-xl';
    },
    textAreaRows() {
      return this.isMobile ? 10 : 3;
    }
  },
  methods: {
    init() {
      EventBus.$emit("activate-indicated-menu-item", "Cyber Corner");
      /* The footer height no longer needs to be set */
      // this.initFooterHeight();
    },
    initFooterHeight() {
      var footerHeight = $('footer').outerHeight();
      $('.main-content').css('margin-bottom', footerHeight);
    },
    onBookmarkPage() {
      console.log('Bookmark Page');
      if (!isLoggedIn()) {
        console.warn('Not Logged In');
        this.$refs['my-modal'].show();
      } else {
        this.bookmarkPage();
      }
    },
    async bookmarkPage() {
      /*  API call to server: GET /api/resources/blogs */
      //console.log('Bookmarking', this.url, this.title, this.type);
      console.log("this.isPageBookmarkedId", this.isPageBookmarkedId);
      if (this.isPageBookmarkedId == null) {
        axios
          .post(`/api/bookmark`, {
            url: this.url,
            title: this.title,
            type: this.type,
          })
          .then((response) => {
            //console.log('Bookmark Response', response);
            this.isPageBookmarked = response.data.isPageBookmarked;
            this.isPageBookmarkedId = response.data.id;
          })
          .catch((error) => {
            handleApiError(error, this.$router);
          });
      }
      else {
        axios
          .delete("/api/bookmark/" + this.isPageBookmarkedId)
          .then((response) => {
            //console.log('Bookmark Response', response);
            this.isPageBookmarked = false;
            this.isPageBookmarkedId = null;
          })
          .catch((error) => {
            handleApiError(error, this.$router);
          });
      }

    },
    //TODO: Check if bookmarked
    async checkIfBookmarked() {
      console.log('Checking if Bookmarked', this.url);
      axios
        .post(`/api/bookmark/isBookmarked`, {
          url: this.url
        })
        .then((response) => {
          console.log('Is Bookmarked Response', response);
          this.isPageBookmarked = response.data.isPageBookmarked;
          this.isPageBookmarkedId = response.data.id ? response.data.id : null ;
        })
        .catch((error) => {
          handleApiError(error, this.$router);
        });
    },
    initiateLike() {
      if (!isLoggedIn()) {
        console.warn('Not Logged In');
        this.$refs['my-like-modal'].show();
      } else {
        this.toggleLike();
      }
    },
    toggleLike() {
      if (this.liked) {
        this.unlikeBlog()
      } else {
        this.likeBlog()
      }
    },
    likeBlog() {
      this.liked = true;

      axios.post('/api/likes', { 'blogId': this.id }).then((resp) => {
        this.liked = true;
        this.likeId = resp.data;
        this.numOfLikes++;
      });
    },
    unlikeBlog() {
      this.liked = false;

      axios.delete('/api/likes/' + this.blogId).then((resp) => {
        this.liked = false;
        this.numOfLikes--;
      });
    },
    loadLikeNum(id) {
      axios.get('/api/likes/num/' + id).then((resp) => {
        this.numOfLikes = resp.data.numOfLikes || 0;
      });
    },
    loadLike(id) {
      axios.get('/api/likes/' + id).then((resp) => {
        this.likeId = resp.data.likeId || null;
        if (this.likeId != null) {
          this.liked = true;
        }
      });
    },
    async getResource(id) {
      const today = moment().valueOf();
      const fromTheLastSixMonths = moment().subtract(6, 'months').valueOf();

      const blogItems = this.isRecentBlogs.toString() === 'true' 
                          ? this.$store.state.blogItems.filter(({ date }) => (moment(date).valueOf() > fromTheLastSixMonths) && (moment(date).valueOf() < today)) 
                          : this.$store.state.blogItems.filter(({ date }) => moment(date).valueOf() < fromTheLastSixMonths);

      // const blogItems = this.$store.state.blogItems;

      /*  API call to server: GET /api/resources/blogs */
      axios
        .get(`/api/resources/blogs/${id}`)
        .then((response) => {
          if (response.data.Items.length > 0) {
            /** Does an item exist for the query id */
            this.item = response.data.Items[0];
            const currentBlogIndex = blogItems.findIndex(({ title }) => title === this.item.title);

            /* Get Previous Blog Item  */
            const previousBlogItem = blogItems.find((_, index) => index === (currentBlogIndex - 1));
            this.previousBlogId = previousBlogItem?.id;

            /* Get Next Blog Item */
            const nextBlogItem = blogItems.find((_, index) => index === (currentBlogIndex + 1));
            this.nextBlogId = nextBlogItem?.id;

            //console.log(response.data);
          } else {
            /** If no item exists with the id, redirect to list*/
            this.$router.push({ path: 'blog' });
          }
        })
        .catch((error) => {
          /** On error, redirect back to list */
          console.error(error);
          this.$router.push({ path: 'blog' });
        });
    },
    async getComments() {

      try {
        this.commentsLoading = true;
        let commentsResult = await axios.get(`/api/blogcomments/approved/${this.id}`);
        this.comments = commentsResult.data;
      } catch (err) {
        console.log(err)
      } finally {
        this.commentsLoading = false
      }

    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },
    flashSubmitMessage() {
      this.commentSubmitted = true;
      setTimeout(() => {
        this.commentSubmitted = false;
      }, "5000");
    },
    async createComment() {
      if(this.isLoggedIn){
        this.commentName =  this.$store.getters.getUser.name
        this.commentEmail =  this.$store.getters.getUser.email
      }
      let errorsFound = [];
      if (!this.commentBody) {
        this.commentBodyError = true;
        errorsFound.push("Please enter your comment");
      }

      if (!this.commentName) {
        this.commentNameError = true;
        errorsFound.push("Please enter your name");
      }

      if (!this.commentEmail) {
        this.commentEmailError = true;
        errorsFound.push("Please enter a your email");
      }

      if (!this.validateEmail(this.commentEmail)) {
        this.commentEmailError = true;
        errorsFound.push("Please enter a valid email");
      }

      if (errorsFound.length > 0) {
        this.commentFormError = errorsFound.join(', ');
        return;
      }

      // create comment
      try {
        this.createCommentLoading = true;
        let payload = {
          email: this.commentEmail,
          blogId: this.id,
          commentBody: `${this.commentBody}`,
          commentName: this.commentName
        }
        await axios.post('/api/blogcomments/', payload);
        this.commentName = "";
        this.commentEmail = "";
        this.commentBody = "";
        this.commentFormError = "";
        this.flashSubmitMessage();
      } catch (err) {
        console.log(err);
      } finally {
        this.createCommentLoading = false;
      }
    },
    insert(emoji) {
      this.commentBody += emoji
    },
    handleScroll(evt) {
      if (window.scrollY > 50) {
        this.titleVisible = false;
      } else if (window.scrollY < 50)
        this.titleVisible = true;
    },
  },
};
</script>

<style>
.title-area {
  height: 120px !important;
}

.bread-crumb-area-short {
  max-height: 130px !important;
}

.post-image {
  height: 175px !important;
}

.post-image img {
  max-height: 175px;
  object-fit: cover;
  width: 100%;
}

.post-image-footer {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #949494;
  padding-bottom: 15px;
  padding-top: 15px;
}

.post-snippet-no-margin {
  margin-right: 0px !important;
}

.create-comment-area {
  margin-top: 25px;
}

.create-comment-area h3 {
  font-size: 22px;
  margin-top: 5px;
}

.create-comment-area p.paragraph-text {
  color: #272727;
  font-family: GeomGraphic;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
p.paragraph-text-xs-sm {
  font-size: 16px;
}
p.paragraph-text-md-lg-xl {
  font-size: 20px;
}

.create-comment-area .comments {
  color: #22449D;
  font-family: Rajdhani;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.social-button-area-left {
  display: flex;
  align-items: center;
}

.social-button-area-left-text {
  font-size: 17px;
  margin: 0;
}

.form-error {
  font-size: 14px;
  color: rgb(237, 54, 112);
  margin-top: 5px;
}

.comment-area {
  min-height: 100px;
  border: 1px solid #ebebeb;
  border-radius: 5px;
}

.emoticon-area {
  max-height: 150px;
  padding: 7px;
  overflow: auto;
  border-top: 1px solid #f5f5f5;
  border-left: 1px solid #a4a4a4;
  border-right: 1px solid #a4a4a4;
  border-bottom: 1px solid #a4a4a4;
}

.emoticon-area h5 {
  font-size: 16px;
}

.comment-area-body>div:first-of-type {
  display: flex;
  flex: 1;
}

.comment-area-body>div:last-of-type {
  padding: 15px;
}

.input-text-label {
  color: #272727;
  font-size: 18px;
  font-weight: 600;
  font-family: Rajdhani;
}
.input-text {
  border: 1px solid #a4a4a4;
}

.text-area-stripped {
  border-top: 1px solid #a4a4a4;
  border-left: 1px solid #a4a4a4;
  border-right: 1px solid #a4a4a4;
  padding: 10px !important;

}

.comments-container {
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  /* border: 2px solid #272727; */
}

.empty-comments-message {
  width: 100%;
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #272727;
  font-size: 28px;
  font-weight: 700;
  font-family: Rajdhani;
  text-align: center;
  /* border: 2px solid #272727; */
}

.bookmark-page:hover {
  cursor: pointer;
  opacity: .66;
}
</style>
